
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'root': {'flexGrow': `1`,'backgroundColor': `#ffffff`,'padding': `0 20px`,'minHeight': `5vh`,},'sticky': {'flexGrow': `1`,'backgroundColor': `#ffffff`,'padding': `0 20px`,'minHeight': `5vh`,'position': `fixed`,'top': `0`,'width': `100%`,'display': `flex`,'justifyContent': `center`,'padding': `0px 20px`,'backgroundColor': `#ffffff`,},'tabsComponent': {'indicatorColor': `primary`,'textColor': `primary`,'centered': `false`,'scrollable': `true`,},'tabs': {'minHeight': `5vh`,},'tab': {'fontFamily': `'Lato-Regular', sans-serif`,},'selected': {'fontWeight': `bold`,},'moreButton': {'paddingTop': `16px`,'color': `#000000`,},'menu': {'width': `'35ch'`,},
        
      };
    };
  